export default "__VITE_ASSET__BqCply$m__";